<form #form="ngForm" novalidate>
    <div class="row container-form-list mb-3">
        <div class="col-12">
            <div class="row">
                <div class="form-group col-12">
                    <label class="col-form-label" for="grupoClassificacao">Grupo de Segmentos</label>
                    <sgt-grupo-classificacao-select
                        #grupoClassificacaoSelect
                        [ngModel]="idGrupoClassificacao"
                        (ngModelChange)="onChangeGrupoClassificacao($event)"
                        (classificacoesChange)="onChangeGrupoClassificacoes($event)"
                        name="grupoClassificacao"
                        id="grupoClassificacao"
                        required="required"
                        [somenteAtivos]="true"
                        [considerarClienteAnaliseMercado]="true"
                        #grupoClassificacao="ngModel">                                
                    </sgt-grupo-classificacao-select>
                    <p class="form-text text-muted">Selecione o grupo para adicionar os segmentos neste lançamento</p>
                    <sgt-form-control-error
                        *ngIf="grupoClassificacao.errors && grupoClassificacao.errors.required && grupoClassificacao.dirty"
                        msgError="O grupo é obrigatório">
                    </sgt-form-control-error>                      
                </div>
            </div>
            
            <!-- Classificações -->
            <ng-template [ngIf]="idGrupoClassificacao">
                <sgt-grupo-classificacao-classificavel-form
                    #formClassificacoes
                    [entities]="entitiesCreate"
                    [somenteClassificacoesAtivas]="true">
                </sgt-grupo-classificacao-classificavel-form>
            </ng-template>
        </div>
    </div>    
</form>